import React, { useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { getElementOnFocus, getElementToCopy } from '../../../store/global/selectors';
import { setElementToCopy, setExpanded } from '../../../store/global/actions';
import errorConvertor from '../../../services/errorConvertor';
import { invokePostService } from '../../../store/global/actions'

const DeleteSection = (props) => {

    const { id, onClose, onCompletion } = props
    const dispatch = useDispatch();
    const [validationErrors, setValidationErrors] = useState([]);
    const [isForceDelete, setIsForceDelete] = useState(false);
    const [loading, setLoading] = useState(false);

    const copiedElement = useSelector(getElementToCopy);
    const elementOnFocus = useSelector(getElementOnFocus);

    const onDelete = () => {
        setLoading(true);
        if (copiedElement?.id === id) {
            dispatch(setElementToCopy({}))
        }
        
        dispatch(invokePostService('deleteSection', { isForceDelete, clusterletId: elementOnFocus.id }, [id])).then(res => {
            if (res?.status === true) {
                dispatch(setExpanded("1"))
                onCompletion('Section', 'delete')
            } else {
                const errors = res?.data?.validationErrors ? res?.data?.validationErrors : [];
                if (errors.length > 0) {
                    const converter = new errorConvertor(errors);
                    converter.customConvert('The [item] is used in [feature] [featureEntity]');
                    setValidationErrors([...converter.sentences]);
                    setIsForceDelete(true)
                }
                if (res?.code === 255) {
                    onClose();
                }
            }
            setLoading(false);
        });
    }

    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12}>
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12} >
                <Typography>  Are you sure you want to delete Section ? </Typography>
                {validationErrors.length > 0 && <Fragment>
                    <br />
                    <ol>
                        {validationErrors.map((item, index) =>
                            <li key={index}> {item.error} </li>
                        )}
                    </ol>
                </Fragment>}
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={loading} content={loading ? 'Deleting..' : isForceDelete ? 'Delete Anyway' : 'Delete'} />
            </Grid>


        </Grid>
    )
}

export default DeleteSection;